export const JSON_API_MIME_TYPE = 'application/vnd.api+json' as const

export const JSONAPI_HEADERS = Object.freeze({
  'Content-Type': JSON_API_MIME_TYPE,
  'Accept': JSON_API_MIME_TYPE,
})
